Alpine.store('pricelist', {

    products: [],
    blink: null,
    quotation: false,
    register_at: null,
    contact: null,
    invoice_taxes: [],
    taxe_items: [],
    pay_items: [],
    pay_with: null,
    wid: null,
    received: undefined,
    name: undefined,

    reset() {
        this.products = [];
        this.blink = null;
        this.quotation = false;
        this.register_at = null;
        this.contact = null;
        this.invoice_taxes = [];
        this.pay_with = 'cash';
        this.storage?.persist();
        this.received = undefined;
        this.name = null;
    },

    formData() {
        const pay_items = this.pay_items || [];
        const pay_with = this.pay_with || (pay_items[0]?.code);

        return {
            products: this.products,
            quotation: this.quotation,
            register_at: this.register_at,
            contact: this.contact ? this.contact : null,
            invoice_taxes: this.invoice_taxes,
            contact:this.contact,
            name:this.name,
            pay_with,
            received: this.getReceived()
        };
    },

    setReceived(evt) {
        this.received = rwsp(evt.target.value);
    },

    getReceived() {
        if (this.received !== undefined) return this.received;
        return this.net;
    },

    get du() {
        let r = this.getReceived();
        let net = this.net;
        if (isNaN(net) || isNaN(r) || !r || !net) return null;
        return net - r;
    },

    isEmpty() {
        return !!(this.products?.length)
    },

    get storage() {
        if (!localStorage) {
            return null;
        }

        let store = this;
        return {
            persist() {
                const data = {
                    products: store.products,
                    quotation: store.quotation,
                    register_at: store.register_at,
                    contact: store.contact,
                    invoice_taxes: store.invoice_taxes,
                    pay_with: store.pay_with,
                    wid: store.wid
                }
                localStorage.setItem('pricelist_data', JSON.stringify(data))
            },
            data() {
                return JSON.parse(localStorage.getItem('pricelist_data') || '{}');
            },
            restore(data) {
                if (!data) data = this.data();
                store.products = data.products || [];
                store.quotation = data.quotation ? true : false;
                store.register_at = data.register_at;
                store.contact = data.contact;
                store.invoice_taxes = data.invoice_taxes || [];
                store.pay_with = data.pay_with;
            },
            reset() {
                localStorage.removeItem('pricelist_data');
            }
        }
    },

    prod: function (prod) {
        const store = this;
        return {

            get add() {
                //check if product already exist
                let old = store.products.find(p => p.id == prod.id);
                if (old) old.qte = (old.qte || 1) + 1;

                else {
                    store.products.unshift({
                        id: prod.id,
                        qte: 1,
                        price: prod.price,
                        discount: prod.discount,
                        lot: prod.lot,
                        expire_at: prod.expire_at,
                        original: prod
                    });
                }
                store.storage?.persist();
                this.blink();
            },

            get remove() {
                store.products.splice(store.products.indexOf(prod), 1);
                store.storage?.persist();
                return prod;
            },

            blink() {
                store.blink = prod.id;
                setTimeout(() => store.blink = undefined, 500);
            },

            get txo() {
                return store.taxe_items?.find(t => t.code == prod?.original.taxgroup && t.type == "P");
            },

            get ttc() {
                return prod.price * prod.qte;
            },

            get ht() {
                let txo = this.txo;
                if (!txo?.content) return this.ttc;
                return this.ttc * 100 / (100 + txo.content)
            },

            get taxe() {
                return this.ttc - this.ht;
            },

            get discount() {
                if (prod.discount) return this.ht * prod.discount / 100;
                return 0;
            },

            get real_ht() {
                if (!this.discount) return this.ht;
                return this.ht - this.discount;
            },

            get real_taxe() {
                if (!this.discount) return this.taxe;
                let txo = this.txo;
                if (txo?.content) return this.real_ht * txo.content / 100;
                return 0;
            },

            get real_ttc() {
                if (!this.discount) return this.ttc;
                return this.real_ht + this.real_taxe;
            },
        }
    },

    prods: function () {
        let store = this;
        return {
            get ttc() {
                let a = 0;
                store.products.forEach(p => a += store.prod(p).ttc);
                return a;
            },

            get real_ttc() {
                let a = 0;
                store.products.forEach(p => a += store.prod(p).real_ttc);
                return a;
            },

            get ht() {
                let a = 0;
                store.products.forEach(p => a += store.prod(p).ht);
                return a;
            },

            get real_ht() {
                let a = 0;
                store.products.forEach(p => a += store.prod(p).real_ht);
                return a;
            },

            get discount() {
                let a = 0;
                store.products.forEach(p => a += store.prod(p).discount);
                return a;
            }
        }
    },

    taxes: function () {

        let store = this;

        return {
            toggle(taxe) {
                var i = store.invoice_taxes.indexOf(taxe);
                if (i === -1)
                    store.invoice_taxes?.push(taxe);
                else
                    store.invoice_taxes?.splice(i, 1);
            },

            has(id) {
                return !!store.invoice_taxes.find(el => `${el}` === `${id}`);
            },

            invoice(id = null) {

                if (id) {
                    if (!this.has(id)) return 0;
                    const t = store.taxe_items.find(el => el.id == id);
                    if (!t) return 0;
                    return store.prods().real_ht * t.content / 100;
                } else {
                    let a = 0;
                    store.invoice_taxes.forEach(t => {
                        a += this.invoice(t) || 0;
                    })
                    return a;
                }
            },

            get prods() {
                let a = 0;
                store.products.forEach(p => a += store.prod(p).real_taxe);
                return a;
            }

        }
    },

    get net() {
        return this.prods().real_ttc + this.taxes().invoice();
    },

});

Alpine.data('pricelist', function(initial = {}) {

    return {
        init() {
            const store = this.$store.pricelist;
            store.taxe_items = initial.taxe_items;
            store.pay_items = initial.pay_items;
            store.register_at = initial.register_at;
            store.name = initial.name;
            store.wid = initial.wid;

            const old = store.storage?.data();
            if (old.wid != initial.wid) {
                store.storage?.reset();
            } else {
                store.storage?.restore();
            }
        },

        pricelist_reset() {
            this.$store.pricelist.reset();
            this.$store.pricelist.storage.reset();
            $("#pos-s2-product").val(null).trigger('change');
        },

        pricelist_submit() {
            const store = this.$store.pricelist;
            this.$wire.call('save_pricelist', store.formData());
        }
    }
});
